import { render, staticRenderFns } from "./quality-report.vue?vue&type=template&id=febbf422&scoped=true"
import script from "./quality-report.vue?vue&type=script&lang=js"
export * from "./quality-report.vue?vue&type=script&lang=js"
import style0 from "./quality-report.vue?vue&type=style&index=0&id=febbf422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febbf422",
  null
  
)

export default component.exports